export default __webpack_public_path__ + "static/media/css.15bc0a89.png";